import { render, staticRenderFns } from "./CourseImagesCarousel.vue?vue&type=template&id=dbcaf6ee&scoped=true"
import script from "./CourseImagesCarousel.vue?vue&type=script&lang=js"
export * from "./CourseImagesCarousel.vue?vue&type=script&lang=js"
import style0 from "./CourseImagesCarousel.vue?vue&type=style&index=0&id=dbcaf6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcaf6ee",
  null
  
)

export default component.exports